import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { fetchPublicTermsDetail } from "@/lib/api";
import type { PublicTermsDetail } from "@/types";
import PublicTermsLayout from "../terms/PublicTermsLayout";

const policyBadgeLabel = (termsTypeCode: string, requiredYn: string) => {
  if (termsTypeCode === "PRIVACY_POLICY") return "안내";
  return requiredYn === "Y" ? "필수 약관" : "선택 약관";
};
import { AdminCard } from "@/components/admin/data-display/AdminCard";
import { TermsMarkdown } from "@/components/terms/TermsMarkdown";

const PublicTermsDetailPage = () => {
  const { termsTypeCode = "" } = useParams();
  const [searchParams] = useSearchParams();
  const userType = searchParams.get("userType") ?? undefined;
  const version = searchParams.get("version") ?? undefined;
  const [policy, setPolicy] = useState<PublicTermsDetail | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setPolicy(null);
    setError("");
    fetchPublicTermsDetail(termsTypeCode, { userType, version })
      .then(setPolicy)
      .catch((reason) => setError(reason instanceof Error ? reason.message : "약관을 불러오지 못했습니다."));
  }, [termsTypeCode, userType, version]);

  return (
    <PublicTermsLayout>
      <Link to={`/terms${userType ? `?userType=${userType}` : ""}`} className="inline-flex min-h-10 items-center gap-1 rounded-lg px-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-50">← 약관 목록</Link>
      {error && <p role="alert" className="mt-4 rounded-xl border border-rose-200 bg-rose-50 p-6 text-sm text-rose-700">{error}</p>}
      {!error && !policy && <p className="mt-4 rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-500">약관을 불러오는 중입니다.</p>}
      {policy && (
        <AdminCard className="mt-4 overflow-hidden rounded-xl">
          <article>
          <header className="border-b border-slate-200 px-5 py-6 sm:px-8">
            <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500"><span className="rounded-full border border-blue-100 bg-blue-50 px-2 py-0.5 font-semibold text-blue-700">{policyBadgeLabel(policy.termsTypeCode, policy.requiredYn)}</span><span>시행일 {policy.effectiveDate}</span><span>·</span><span>{policy.version}</span></div>
            <h1 className="mt-3 break-keep text-2xl font-bold leading-tight sm:text-3xl">{policy.title}</h1>
          </header>
          <TermsMarkdown content={policy.content} className="px-5 py-7 sm:px-8 sm:py-10" />
          </article>
        </AdminCard>
      )}
    </PublicTermsLayout>
  );
};

export default PublicTermsDetailPage;
